// Prismjs
// https://prismjs.com/#basic-usage
import Prism from 'prismjs';

// Prism Load Languages
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-markup';

// Prism Plugins
import 'prismjs/plugins/line-numbers/prism-line-numbers.js';

// Prism Styles
import 'prismjs/themes/prism-okaidia.css'; // or 'prism.css' for default
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';

// Intl Tel Input
// import intlTelInput from 'intl-tel-input';
// import 'intl-tel-input/build/css/intlTelInput.css';

document.addEventListener('DOMContentLoaded', () => {
    // Prism
    document.querySelectorAll('pre code').forEach((codeBlock) => {
        const pre = codeBlock.parentElement;
        if (pre && !pre.classList.contains('line-numbers')) {
            pre.classList.add('line-numbers');
        }
    });
    Prism.highlightAll();

    // intl-tel-input
    // const input = document.querySelector<HTMLInputElement>('#phone');
    // if (input) {
    //     const iti = intlTelInput(input, {
    //         initialCountry: 'us',
    //         separateDialCode: true,
    //         formatOnDisplay: true,
    //         utilsScript: '/vendor/intl-tel-input/utils.js', // load at runtime
    //         flagsImagePath: '/vendor/intl-tel-input/img/flags.webp',
    //     });
    //
    //     const form = input.closest('form');
    //     if (form) {
    //         form.addEventListener('submit', () => {
    //             input.value = iti.getNumber(); // E.164
    //         });
    //     }
    // }
});